import axios from "axios";

/** Triggers that open a review-and-send modal before advancing the project phase. */
export const PHASE_COMPLETE_EMAIL_PREVIEW_TRIGGERS = new Set(["networking_complete"]);

export function phaseCompleteEmailUsesPreview(triggerId) {
  return PHASE_COMPLETE_EMAIL_PREVIEW_TRIGGERS.has(String(triggerId || "").trim());
}

export async function fetchPhaseTriggerEmailPreview(apiBaseUrl, projectId, triggerId, getAuthHeaders) {
  const res = await axios.post(
    `${apiBaseUrl}/projects/${projectId}/phase-trigger-email/preview`,
    { triggerId },
    { headers: getAuthHeaders() }
  );
  return res.data;
}

export async function sendPhaseTriggerEmail(apiBaseUrl, projectId, payload, getAuthHeaders) {
  const res = await axios.post(`${apiBaseUrl}/projects/${projectId}/phase-trigger-email`, payload, {
    headers: getAuthHeaders(),
  });
  return res.data;
}
